var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLogoV3 = function SvgLogoV3(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 18,
    viewBox: "0 0 99 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.887.5 9.112 5.464v5.465L8.887 5.964V.5Z",
    fill: "url(#paint0_linear_16761_53097)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.887 17.5 9.112-5.41V6.683L8.887 12.09V17.5Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.887.5 0 5.964v5.465l8.887-5.465V.5Z",
    fill: "#EB9E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.887 17.5 0 12.09V6.683l8.887 5.409V17.5Z",
    fill: "#363636"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.898 13.635h1.42V8.984h.002v-1.22h-.001V3.5h-1.42v10.135Zm2.927-4.651v-1.22L32.38 3.5h1.564l-2.941 4.81v.028l3.127 5.297h-1.606l-2.698-4.651ZM43.613 3.5l-1.98 7.436c-.143.56-.215 1.077-.215 1.077h-.028s-.058-.531-.187-1.077L39.41 3.5h-1.464l2.583 10.135h1.65l1.75-6.575c.172-.646.301-1.435.301-1.435h.029s.13.79.301 1.435l1.75 6.575h1.65L50.616 3.5H49.15l-1.865 7.436a7.028 7.028 0 0 0-.186 1.077h-.029s-.072-.517-.215-1.077L44.876 3.5h-1.263Zm17.98 10.135h-6.126V3.5h5.883v1.235h-4.462v3.172h3.63v1.235h-3.63V12.4h4.706v1.235Zm5.112 0h1.42V7.06c0-.574-.1-1.478-.1-1.478h.028s.474.918.847 1.478l4.519 6.575h1.392V3.5h-1.42v6.59c0 .56.1 1.463.1 1.463h-.029s-.474-.918-.847-1.464L68.111 3.5h-1.406v10.135Zm17.457 0h-1.42v-8.9H79.27V3.5h8.365v1.235h-3.473v8.9Zm13.355 0h1.478L95.35 3.5h-1.492l-3.644 10.135h1.463l.99-2.87.388-1.221 1.133-3.216c.172-.517.402-1.436.402-1.436h.029s.215.92.387 1.436l1.12 3.216.385 1.213 1.006 2.878Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16761_53097",
    x1: 17.935,
    y1: 4.042,
    x2: 8.887,
    y2: 4.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
};
export default SvgLogoV3;